import "./index.css"
import "./mobile.css"
import BackButton from "../back-button/index.js";
import React, { useState, useEffect, useRef } from 'react';
import LiveChat from "../livechat/index.js";

function ChatBox(props) {
  const inputRef = useRef();
  let messageInProg = false;
  const [chatHistory, setchatHistory] = useState([]);
  const [inputValue, setInputValue] = useState(""); // State to track the input value
  const [typingState, setTypingState] = useState(false);

  const addToChatHistory = async(mostRecentMessage) => {
    if(inputValue.replace(/ /g,"")!==""){
    inputRef.current.value = "";
    setTypingState(true);
    const newMessageObject = {"role":"user","content":mostRecentMessage};
    const messageHistoryToSendToAPI = chatHistory.concat([newMessageObject]);
    const currentDiscussionTopic = props.topic;
    const APIPackage = {
      "topic" : currentDiscussionTopic,
      "messageHistory" : messageHistoryToSendToAPI
    }
    setchatHistory(prevChatHistory => [...prevChatHistory, newMessageObject]);
    document.getElementById("text-input").setAttribute("disabled","disabled");
    messageInProg = true;
    let response = await fetch('https://larus-c6a6bad528e1.herokuapp.com/MattBotNewMessage', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json', // Adjust the content type as needed
    // You can also include additional headers if required
  },
  body: JSON.stringify(APIPackage), // Convert your data to JSON
})
if (response.ok) {
  let data = await response.json();
  setchatHistory(prevChatHistory => [...prevChatHistory, data.content]);
  setTypingState(false);
} else {
  setchatHistory(prevChatHistory => [...prevChatHistory, {"role":"assistant","content":"I'm sorry there seems to be an error, please check back later"}]);
  console.log(response.statusText);
}
document.getElementById("text-input").removeAttribute("disabled","disabled");
messageInProg=false;
    }
    };

  useEffect(() => {
    // This useEffect will run whenever chatHistory changes
  }, [chatHistory]);

  const handleInputChange = (event) => {
    const newValue = event.target.value.toString();
    setInputValue(newValue);
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    if(messageInProg===false&&inputValue!==""){
    inputRef.current.value = "";
    addToChatHistory(inputValue); // Call your function when the form is submitted
    setInputValue(""); // Clear the input field
    }
  };

  const clearChatHistory = () => {
   setchatHistory([])
  };

  const handleBackClick = () => {
    props.addFunction();
    clearChatHistory();
  };

    return <div id="message-box">
    <div onClick={handleBackClick}><BackButton color={props.colorOfSection}></BackButton></div>
    <LiveChat messages={chatHistory} opener={props.initialMessage} typingGif={typingState}></LiveChat>
    <form className="chat-entry-form" onSubmit={handleSubmit}>
        <input id="text-input"  ref={inputRef} autoComplete="off" onChange={handleInputChange}></input>
        <img id="send-icon" src="./icons/send.png" alt="small send icon" onClick={handleSubmit}></img>
    </form>
    </div>;
  }

export default ChatBox;
